import Immutable from 'seamless-immutable';
import { GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS } from './actions/workflow.actions';
var INITIAL_STATE = Immutable({
  data: {}
});
var setWorkflowInstancesMap = function setWorkflowInstancesMap(workflowInstances) {
  var workflowInstancesMap = {};
  workflowInstances.forEach(function (workflowInstance) {
    workflowInstancesMap[workflowInstance.Id] = {
      isLoading: false,
      workflowInstance: workflowInstance
    };
  });
  return workflowInstancesMap;
};
var setWorkflowInstancesFailed = function setWorkflowInstancesFailed(workflowInstanceIds, payload) {
  var workflowInstancesMap = {};
  workflowInstanceIds.forEach(function (workflowInstanceId) {
    workflowInstancesMap[workflowInstanceId] = {
      isLoading: false,
      workflowError: {
        code: payload.Code,
        message: payload.Message,
        severity: payload.Severity
      }
    };
  });
  return workflowInstancesMap;
};
var setWorkflowInstancesLoading = function setWorkflowInstancesLoading(workflowInstanceIds) {
  var workflowInstancesMap = {};
  workflowInstanceIds.forEach(function (workflowInstanceId) {
    workflowInstancesMap[workflowInstanceId] = {
      isLoading: true
    };
  });
  return workflowInstancesMap;
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    _ref$requestObject = _ref.requestObject,
    requestObject = _ref$requestObject === void 0 ? {} : _ref$requestObject;
  switch (type) {
    case GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.BEGIN:
      return state.merge({
        data: setWorkflowInstancesLoading(requestObject.workflowInstanceIds)
      }, {
        deep: true
      });
    case GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.SUCCESS:
      return state.merge({
        data: setWorkflowInstancesMap(payload.WorkflowInstances)
      }, {
        deep: true
      });
    case GET_WORKFLOW_ACTIVITY_INSTANCE_STATUS.FAILURE:
      return state.merge({
        data: setWorkflowInstancesFailed(requestObject.workflowInstanceIds, payload)
      }, {
        deep: true
      });
    default:
      return state;
  }
});